import { Helmet } from "react-helmet-async";

const SITE_NAME = "Divine Love Wellness Enterprises";
const DEFAULT_DESCRIPTION =
  "Compassionate, trauma-informed Ketamine-Assisted Psychotherapy with Laura A. Jeanis, LCSW, LICSW, CCTP, CEO. Licensed in FL, ME & DC. Begin your healing journey today.";
const DEFAULT_IMAGE =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_833ff4cd-a791-443f-9fd4-023fdfa8f8c0/artifacts/aw1u5wyo_D.png";

const SEO = ({
  title,
  metaTitle,
  keywords,
  description,
  image,
  imageAlt,
  type = "website",
  pathname = "",
  publishedTime,
  author,
  noIndex = false,
}) => {
  const customTitle = metaTitle?.trim();
  const fullTitle = customTitle || (title ? `${title} | ${SITE_NAME}` : SITE_NAME);
  const desc = description || DEFAULT_DESCRIPTION;
  const trimmedDescription =
    desc.length > 160 ? `${desc.slice(0, 157).trim()}...` : desc;
  const ogImage = image || DEFAULT_IMAGE;

  const origin = "https://divinelovewellness.net";
  const path =
    pathname ||
    (typeof window !== "undefined" ? window.location.pathname : "");
  const canonical = origin + path;

  const meta = [
    { name: "description", content: trimmedDescription },
    { property: "og:site_name", content: SITE_NAME },
    { property: "og:title", content: fullTitle },
    { property: "og:description", content: trimmedDescription },
    { property: "og:type", content: type },
    { property: "og:url", content: canonical },
    { property: "og:image", content: ogImage },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: fullTitle },
    { name: "twitter:description", content: trimmedDescription },
    { name: "twitter:image", content: ogImage },
  ];
  const keywordList = [...new Set((keywords || []).map((k) => k?.trim()).filter(Boolean))];
  if (keywordList.length) {
    meta.push({ name: "keywords", content: keywordList.join(", ") });
  }
  if (imageAlt) {
    meta.push({ property: "og:image:alt", content: imageAlt });
    meta.push({ name: "twitter:image:alt", content: imageAlt });
  }
  if (noIndex) {
    meta.push({ name: "robots", content: "noindex,nofollow" });
  } else {
    // Explicit positive signal so no crawler ever has any doubt.
    meta.push({ name: "robots", content: "index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" });
  }
  if (publishedTime)
    meta.push({ property: "article:published_time", content: publishedTime });
  if (author) meta.push({ property: "article:author", content: author });

  return (
    <Helmet
      title={fullTitle}
      meta={meta}
      link={[{ rel: "canonical", href: canonical }]}
      script={
        keywordList.length
          ? [
              {
                type: "application/ld+json",
                innerHTML: JSON.stringify({
                  "@context": "https://schema.org",
                  ...(type === "article"
                    ? {
                        "@type": "BlogPosting",
                        headline: title,
                        ...(author && { author: { "@type": "Person", name: author } }),
                        ...(publishedTime && { datePublished: publishedTime }),
                        ...(image && { image }),
                        mainEntityOfPage: canonical,
                      }
                    : { "@type": "WebPage", name: fullTitle }),
                  url: canonical,
                  description: trimmedDescription,
                  keywords: keywordList.join(", "),
                  about: keywordList.map((k) => ({ "@type": "Thing", name: k })),
                }),
              },
            ]
          : []
      }
    />
  );
};

export default SEO;
